import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UpdateLocationInputDto } from '../../../models/location/dto/create-location.dto';
import { OrganizationLocationDto } from '../../../models/location/dto/location.dto';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { GET_LOCATION_QUERY_KEY } from './useGetLocation';

export const useUpdateLocation = (locationId: string, onSuccess: (data: OrganizationLocationDto) => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization } = useSelectedOrganization();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateLocation', locationId],
        mutationFn: async (body: UpdateLocationInputDto) => {
            const response = await apiClient.fetchApi<OrganizationLocationDto, UpdateLocationInputDto>({ method: 'PUT', endpoint: `organizations/${selectedOrganization?.id}/locations/${locationId}`, body });
            return response
        },
        onSuccess: (data) => {
            onSuccess(data);
            queryClient.setQueryData(GET_LOCATION_QUERY_KEY(data.id), data)
        }
    });
};